import { Link } from '@mui/material';

const SPECIFICATION_SOURCE_URL = 'https://github.com/BerriAI/litellm/blob/main/model_prices_and_context_window.json';

const SpecificationSourceLink = () => (
  <Link href={SPECIFICATION_SOURCE_URL} target="_blank" rel="noreferrer">
    LiteLLM repository
  </Link>
);

export default SpecificationSourceLink;
